<template>
<div>

  <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>Backstage crew</h1>
        </div>
    </section>
  </div>

  <section class="section">
  <div class="container">
    <div class="content">

      <div class="columns">
        
        <div class="column is-two-thirds">
          <h1>Join the backstage crew</h1>

          <p>The Penguin Club exists to provide backstage support to amateur societies in and around Cambridge. Its services are provided free; and within its membership there are Set Designers, Lighting Designers and Sound Engineers.</p>

          <p>It will put a call out for Crew, has several SMs and ASMs; and experts in Props. This highly respected club attempts to provide as much technical backup as required for the successful staging of a society’s performances.</p>

          <a href="http://penguinclub.org.uk/" target="_blank">&gt; The Penguin Club</a>

        </div>

      </div>
    </div>
  </div>
  </section>
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    created() { 
      this.$store.commit('setContentLoaded', true); // then footer will be displayed
    },
    metaInfo: {
      title: "Backstage crew",
      // titleTemplate: null // override the parent template and just use the above title only
      
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Backstagecrew.vue